

















































import Vue from "vue";
import SlotGroup from "@/components/arma/slots/SlotGroup.vue";
import UserChip from "../../users/UserChip.vue";
import Event from "@/classes/Event";
import User from "@/User";

export default Vue.extend({
  components: {
    SlotGroup,
    UserChip,
  },
  props: {
    event: {
      type: Object as () => Event,
      required: true,
    },
    eventHasFinished: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    user() {
      return User.get();
    },
  },
  methods: {
    login() {
      User.login();
    },
    async joinReserve() {
      await this.axios.post(`/arma/slots`, {
        event: this.event.id,
      });

      this.$emit("reload-event");
    },
  },
});
